import {Link, useNavigate} from "react-router-dom";
import { useGlobal } from "../../utils/GlobalContext";

export default function Sessions() {
    const { state } = useGlobal();
    const navigate = useNavigate();
    if (state.UserProfile.IsExistingUser === false) {
      navigate("/account");
  }
    return (
        <div>
            <h1>sessions</h1>
            <h6>sessions\Sessions.jsx</h6>

            <Link to={"35131"}>Session #35131</Link>
        </div>
    )
}